class LocalStorage {
  public static AUTH_TOKEN: string;
  public static ROLE: string;
}
export default LocalStorage;
